import http from "../api/http";
import { api } from "../api/environment";
import { ServerResponse, IClient, IClientSummary } from "../types/global";

const getAll = (
  maxResultCount: number,
  skipCount?: number,
  search?: string
) => {
  return http.get<ServerResponse<IClient>>(
    `/services/app${api.CLIENT_SERVICE}/GetAll?${
      maxResultCount ? "MaxResultCount=" + maxResultCount + "&" : ""
    }${skipCount ? "SkipCount=" + skipCount + "&" : ""}${
      search ? "Search=" + search + "&" : ""
    }`
  );
};

const get = (id: number) => {
  return http.get<IClient>(`/services/app${api.CLIENT_SERVICE}/Get?Id=${id}`);
};

const create = (payload: IClient) => {
  return http.post<IClient>(
    `/services/app${api.CLIENT_SERVICE}/Create`,
    payload
  );
};

const remove = (id: number) => {
  return http.delete<IClient>(
    `/services/app${api.CLIENT_SERVICE}/Delete?clientId=${id}`
  );
};

const put = (payload: IClient) => {
  return http.put<IClient>(
    `/services/app${api.CLIENT_SERVICE}/Update`,
    payload
  );
};

const getSummary = (id: number) => {
  return http.get<IClientSummary>(
    `/services/app${api.CLIENT_SERVICE}/GetClientSummaryByClientId?clientId=${id}`
  );
};

export const clientService = { getAll, get, create, remove, put, getSummary };
